import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import ProtectedRoute from './components/ProtectedRoute';
import SignIn from './routes/SignIn';
import AuthSent from './routes/AuthSent';
import Dashboard from './routes/Dashboard';
import BriefIntake from './routes/BriefIntake';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/auth/sent" element={<AuthSent />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/intake/:sessionId" element={<BriefIntake />} />
        </Route>

        {/* Fallback — redirect unknown paths through the protected gate */}
        <Route path="*" element={<ProtectedRoute />} />
      </Routes>
    </AuthProvider>
  );
}
